<template>
    <div class="app-container">
        <el-row :gutter="10">
                <template >
                    <el-col>
                        <el-card class="box-card">
                            <!--form 组件-->
                            <eForm ref="form" :is-add="isAdd" :sup-this="supThis"/>
                            <pass-form ref="resetPassword" :sup-this="supThis"/>

                            <!-- 搜索-->
                            <dynamic-search
                                :data="tableFilterList(tableHead)"
                                @search="dataTableSearch">
                                <template v-slot:next>
                                    <el-button icon="el-icon-plus" @click="add">新增</el-button>
                                </template>
                            </dynamic-search>
                            <edit-data-table
                            :head="tableHead"
                            :data.sync="list"
                            :config="{trigger: 'click', mode: 'cell'}"
                            :total="total"
                            :offset="offset"
                            :page="page"
                            :loading="loading"
                            stripe
                            @handlePageChange="dataTablePageChange"
                            @handleSizeChange="dataTableSizeChange"
                            :tool-bar="{label: '操作', align: 'center', width: 150}">
                              <template #toolbar="scope">
                                <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
                                <el-popover :ref="scope.row.id" placement="top" width="180">
                                    <p>确定删除本条数据吗？</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                                        <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
                                    </div>
                                    <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
                                </el-popover>
                                 <el-tooltip effect="dark" content="重置密码" placement="bottom">
                                    <el-button
                                        size="mini"
                                        type="text"
                                        icon="el-icon-key"
                                        @click="reset(scope.row)">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="模拟TA登录" placement="bottom">
                                    <el-button
v-if="isAdmin"
                                        size="mini"
                                        type="text"
                                        icon="el-icon-thumb"
                                        @click="simulationLoginClick(scope.row.id)">
                                    </el-button>
                                </el-tooltip>
                              </template>
                              <template #enabled="{row}">
                                  <el-tag :type="row.enabled ? '' : 'info'">{{ row.enabled ? '启用' : '禁用'}}</el-tag>
                              </template>
                          </edit-data-table>
                        </el-card>
                    </el-col>
                </template>
        </el-row>
    </div>
</template>

<script>
    import "@/components/EditDataTable"
    import DynamicSearch from "@/components/DynamicSearch/index.vue";
    import DataTableMixin from '@/mixins/DataTableMixin'
    import {tableSataus} from '@/views/bill/mixins/status'
    import {del} from "@/api/user";
    import {getDeptTree} from "@/api/dept";
    import eForm from "./form";
    import passForm from "./ResetPassword"
    import {deepClone} from "@/utils/index";

    export default {
        name: "User",
        mixins: [DataTableMixin,tableSataus],
        components: {
            DynamicSearch,
            eForm,
            passForm
        },
        data() {
            return {
                delLoading: false,
                supThis: this,
                isAdd: false,
                treeData: [],
                treeProps: {
                    children: "children",
                    label: "name"
                },
                tableHead: [
                    {
                        label: "员工姓名",
                        prop: "name",
                        query: {
                            type: "input"
                        },
                        sortable: true
                    },
                    {
                        label: "员工编号",
                        prop: "code"
                    },
                    {
                        label: "登录账号",
                        prop: "account"
                    },
                    {
                        label: "邮箱",
                        prop: "email"
                    },
                    {
                        label: "手机号",
                        prop: "phone"
                    },
                    {
                        label: "岗位",
                        prop: "postName",
                    },
                    {
                        label: "部门",
                        prop: "deptName",
                    },
                    {
                        label: "是否启用",
                        prop: "enabled",
                        width: 100
                    },
                    {
                        label: "创建时间",
                        prop: "created"
                    },
                ],
                deptId: "",
                deptName: ""
            };
        },
        created() {
          // 列表数据初始化
          this.$nextTick(() => {
            this.getDeptTree();
            this.dataTableInit();
          });
        },
        methods: {
            dataTableBeforeInit() {
                this._url = '/user/list'
                const params = { page: this.page, size: this.offset,  deptId: this.deptId, }
                this._params = Object.assign(params,this._query)
                return true
            },
            getDeptTree() {
                getDeptTree().then(res => {
                    this.treeData = res.data || []
                });
            },
            handleDeletes(rows) {
                rows.forEach(element => {
                    this.subDelete(element.id);
                });
            },
            subDelete(id) {
                this.delLoading = true;
                del(encodeURIComponent(id)).then(res => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                    this.dleTableChangePage()
                    this.dataTableInit()
                    this.$notify({
                        title: '删除成功',
                        type: 'success',
                        duration: 2500
                    })
                }).catch(() => {
                    this.delLoading = false
                    this.$refs[id].doClose()
                });
            },
            reset(data) {
                const _this = this.$refs.resetPassword;
                _this.dialog = true;
                _this.form.id = data.id;
            },
             simulationLoginClick(id) {
                this.$store.dispatch('user/simulationLogin', id).then(() => {
                    this.$router.replace({path: '/dashboard'})
                    location.reload();
                }).catch((res) => {

                })
            },
            add() {
              this.isAdd = true
              const _this = this.$refs.form
              _this.form = {
                enabled: true
              }
              _this.dialog = true
            },
            edit(data) {
                this.isAdd = false;
                const _this = this.$refs.form;
                _this.form = deepClone(data);
                // _this.form.enabled = _this.form.enabled.toString()
                _this.form.person = {
                  id: _this.form.personId,
                  name: _this.form.personName
                }
                _this.dialog = true;
            },
            change(data) {
                if (data.pid === 0) {
                    this.deptId = null;
                } else {
                    this.deptId = data.id;
                }
                this.dataTableInit()
            },
            searchDept() {
                this.$refs.orgTree.$refs.tree.filter(this.deptName);
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            }
        }
    };
</script>

<style scoped lang="scss">
    .tree-container-scroll {
        padding-top: 15px;
        height: 400px;
        /deep/ .el-scrollbar__wrap {
            overflow-x: auto;
        }
    }
    /deep/ .splitter-pane-resizer {
        background-color: #ffffff;
    }
</style>
